var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "pa-0 pb-5", attrs: { cols: "12" } },
        [
          _vm.$store.state.accounts.retrieveLoader
            ? _c("v-skeleton-loader", {
                staticClass: "rounded-md",
                attrs: { transition: "fade-transition", type: "article" },
              })
            : _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "py-0 px-2", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { flat: "" } },
                        [
                          _c(
                            "v-toolbar",
                            {
                              attrs: {
                                color: "transparent",
                                flat: "",
                                height: "46",
                              },
                            },
                            [
                              _c(
                                "v-toolbar-title",
                                {
                                  staticClass:
                                    "px-5 subtitle-2 grey-700--text font-weight-bold",
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        "no-gutters": "",
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "16",
                                                left: "",
                                                color: "grey-700",
                                              },
                                            },
                                            [_vm._v("mdi-domain")]
                                          ),
                                          _vm._v(
                                            "Información de la organización"
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-text",
                            { staticClass: "px-5 py-4" },
                            [
                              _c(
                                "v-list",
                                {
                                  staticClass:
                                    "v-list-form-basic transparent pa-0",
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass:
                                            "font-weight-semibold d-flex align-center mr-5",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: "grey-700",
                                                size: "14",
                                                left: "",
                                              },
                                            },
                                            [_vm._v("mdi-domain")]
                                          ),
                                          _vm._v(" Nombre "),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass: "body-1 grey-500--text",
                                        },
                                        [
                                          _vm.editable.name
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-block d-inline-block text-truncate",
                                                  staticStyle: {
                                                    "max-width": "99%",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.editable.name)
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text--disabled font-italic",
                                                },
                                                [_vm._v("Sin especificar")]
                                              ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass:
                                            "font-weight-semibold d-flex align-center mr-5",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: "grey-700",
                                                size: "14",
                                                left: "",
                                              },
                                            },
                                            [_vm._v("mdi-earth")]
                                          ),
                                          _vm._v(" País "),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass: "body-1 grey-500--text",
                                        },
                                        [
                                          _vm.editable.country
                                            ? _c(
                                                "span",
                                                { staticClass: "d-block" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.countriesList.find(
                                                        ({ id }) =>
                                                          _vm.editable
                                                            .country == id
                                                      )?.name
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text--disabled font-italic",
                                                },
                                                [_vm._v("Sin especificar")]
                                              ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass:
                                            "font-weight-semibold d-flex align-center mr-5",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: "grey-700",
                                                size: "14",
                                                left: "",
                                              },
                                            },
                                            [_vm._v("mdi-map-marker")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("generals.Comuna")
                                              ) +
                                              " "
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass: "body-1 grey-500--text",
                                        },
                                        [
                                          _vm.editable.municipality
                                            ? _c(
                                                "span",
                                                { staticClass: "d-block" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.editable.municipality
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text--disabled font-italic",
                                                },
                                                [_vm._v("Sin especificar")]
                                              ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass:
                                            "font-weight-semibold d-flex align-center mr-5",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: "grey-700",
                                                size: "14",
                                                left: "",
                                              },
                                            },
                                            [_vm._v("mdi-map-marker")]
                                          ),
                                          _vm._v(" Dirección "),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass: "body-1 grey-500--text",
                                        },
                                        [
                                          _vm.editable.address
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-block d-inline-block text-truncate",
                                                  staticStyle: {
                                                    "max-width": "99%",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.editable.address)
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text--disabled font-italic",
                                                },
                                                [_vm._v("Sin especificar")]
                                              ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.$store.state.auth.account.country === "CL"
                    ? _c(
                        "v-col",
                        { staticClass: "px-2 mt-5", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _c(
                                "v-toolbar",
                                {
                                  attrs: {
                                    color: "transparent",
                                    flat: "",
                                    height: "46",
                                  },
                                },
                                [
                                  _c(
                                    "v-toolbar-title",
                                    {
                                      staticClass:
                                        "px-5 subtitle-2 grey-700--text font-weight-bold",
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          attrs: {
                                            "no-gutters": "",
                                            align: "center",
                                            justify: "space-between",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    size: "16",
                                                    left: "",
                                                    color: "grey-700",
                                                  },
                                                },
                                                [_vm._v("mdi-bank")]
                                              ),
                                              _vm._v("Información fiscal"),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c(
                                "v-card-text",
                                { staticClass: "px-5 py-4" },
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass:
                                        "v-list-form-basic transparent pa-0",
                                    },
                                    [
                                      _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "font-weight-semibold d-flex align-center mr-5",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: "grey-700",
                                                    size: "14",
                                                    left: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-pound-box-outline"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "generals.Número fiscal"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "body-1 grey-500--text",
                                            },
                                            [
                                              _vm.editable.tax_id
                                                ? _c(
                                                    "span",
                                                    { staticClass: "d-block" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.editable.tax_id
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 text--disabled font-italic",
                                                    },
                                                    [_vm._v("Sin especificar")]
                                                  ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "font-weight-semibold d-flex align-center mr-5",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: "grey-700",
                                                    size: "14",
                                                    left: "",
                                                  },
                                                },
                                                [_vm._v("mdi-bank")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-inline-block text-truncate",
                                                  staticStyle: {
                                                    "max-width": "99%",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Descripción de la actividad"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "body-1 grey-500--text",
                                            },
                                            [
                                              _vm.irsConnection
                                                ?.activity_description
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block body-1 grey-700--text d-inline-block text-truncate",
                                                      staticStyle: {
                                                        "max-width": "99%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.irsConnection
                                                            .activity_description
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 text--disabled font-italic",
                                                    },
                                                    [_vm._v("Sin especificar")]
                                                  ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "font-weight-semibold d-flex align-center mr-5",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: "grey-700",
                                                    size: "14",
                                                    left: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-pound-box-outline"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-inline-block text-truncate",
                                                  staticStyle: {
                                                    "max-width": "99%",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Código de actividad SII"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "body-1 grey-500--text",
                                            },
                                            [
                                              _vm.irsConnection?.activity_code
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block body-1 grey-700--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.irsConnection
                                                            .activity_code
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 text--disabled font-italic",
                                                    },
                                                    [_vm._v("Sin especificar")]
                                                  ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "font-weight-semibold d-flex align-center mr-5",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: "grey-700",
                                                    size: "14",
                                                    left: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-pound-box-outline"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" Fecha de resolución "),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "body-1 grey-500--text",
                                            },
                                            [
                                              _vm.irsConnection
                                                ?.sii_resolution_date
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block body-1 grey-700--text",
                                                    },
                                                    [
                                                      !_vm.$route.path.startsWith(
                                                        "/test"
                                                      )
                                                        ? [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f("date")(
                                                                  _vm
                                                                    .irsConnection
                                                                    .sii_resolution_date
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        : [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f("date")(
                                                                  _vm
                                                                    .irsConnection
                                                                    .sii_test_resolution_date
                                                                )
                                                              )
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 text--disabled font-italic",
                                                    },
                                                    [_vm._v("Sin especificar")]
                                                  ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "font-weight-semibold d-flex align-center mr-5",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: "grey-700",
                                                    size: "14",
                                                    left: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-pound-box-outline"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" Número resolución "),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "body-1 grey-500--text",
                                            },
                                            [
                                              !_vm.$route.path.startsWith(
                                                "/test"
                                              )
                                                ? [
                                                    _vm.irsConnection
                                                      ?.sii_resolution_number
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "d-block body-1 grey-700--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .irsConnection
                                                                  .sii_resolution_number
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-2 text--disabled font-italic",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Sin especificar"
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                : [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-block body-1 grey-700--text",
                                                      },
                                                      [_vm._v("0")]
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }